@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="span9">
  <h1 data-automation-name="powerTypeIndex"> Powertypes</h1>
</div>
<p class="lead">
  Powertypes are descriptions of report interval streams (RIDs). For most RIDs, the RealPower powertype is correct.
</p>
@if(isAdmin) {
  <div class="span3" style="text-align:right;">
    <a id="createPowertype" class="btn btn-large btn-primary" (click)="nextPage($event, '/createPowerType', router)" style="margin-top:9px;"> Create Powertype</a>
  </div>
}

@if(isLoading) {
  <app-loader
    message="Loading Powertypes...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <!-- Column headers -->
    <tr>
      <th>Item Description</th>
      <th>Item Unit</th>
      <th>SI Scale Code</th>
      <th>Hertz</th>
      <th>Voltage</th>
      <th>AC</th>
      <th>Last Modified By</th>
      @if(isAdmin) {
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="Item Description" class="input-sm form-control" type="search" [(ngModel)]="itemDescriptionSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Item Unit" class="input-sm form-control" type="search" [(ngModel)]="itemUnitSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="SI Scale Code" class="input-sm form-control" type="search" [(ngModel)]="siScaleCodeSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Hertz" class="input-sm form-control" type="search" [(ngModel)]="hertzSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Voltage" class="input-sm form-control" type="search" [(ngModel)]="voltageSearch" (input)="triggerSearch()"/></th>
      <th>
        <select class="input-sm form-control" [(ngModel)]="acSearch" (change)="triggerSearch()">
          <option value="">All</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </th>
      <th></th>
      @if(isAdmin) {
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
      @for(powertype of displayedPowerTypes | paginate: paginationModel; track powertype) {
        <tr>
          <td>{{powertype.itemLabel}}</td>
          <td>{{powertype.itemUnit}}</td>
          <td>{{powertype.siScaleCode}}</td>
          <td>{{powertype.hertz}}</td>
          <td>{{powertype.voltage}}</td>
          <td>
            @switch(powertype.ac) {
              @case(true) {
                <span class="badge badge-success">Yes</span>
              }
              @default {
                <span class="badge badge-secondary">No</span>
              }
            }
          </td>
          <td>{{powertype.updated_by}}</td>
          @if(isAdmin) {
            <td>
              <div class="btn-group">
                <a class="btn btn-default" (click)="nextPage(powertype.itemDescription, '/editPowerType', router)" name="editPowertype">Edit</a>
                <button class="btn btn-danger" type="button" (click)="delete(powertype)">Delete</button>
              </div>
            </td>
          }
        </tr>
      }
      @if(displayedPowerTypes.length <= 0) {
        <tr>
          <td [attr.colspan]="isAdmin ? 8 : 7" style="text-align: center;">No powertypes found matching your search criteria.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="isAdmin ? 8 : 7">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
